// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MobileTwoToneSvg from "@ant-design/icons-svg/es/asn/MobileTwoTone";
import AntdIcon from '../components/AntdIcon';

var MobileTwoTone = function MobileTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MobileTwoToneSvg
  }));
};

MobileTwoTone.displayName = 'MobileTwoTone';
export default /*#__PURE__*/React.forwardRef(MobileTwoTone);